





























































































































































































































import DialogBankslipResend from '@/app/shared/components/dialogs/bankslip-resend.vue';
import DialogBrcodeResend from '@/app/shared/components/dialogs/brcode-resend.vue';
import DialogChargebackDetails from '@/app/shared/components/dialogs/chargeback-details.vue';
import DialogInstallmentDetails from '@/app/shared/components/dialogs/installment-details.vue';
import DialogInstallmentEdit from '@/app/shared/components/dialogs/installment-edit.vue';
import DialogPayment from '@/app/shared/components/dialogs/payment.vue';
import DialogRefundHistory from '@/app/shared/components/dialogs/refund-history.vue';
import { InstallmentModel, PaymentInfoModel } from '@/app/shared/models';
import { env } from '@/environments';
import { refsService } from '@/app/shared/refs.service';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { DataTableHeader } from 'vuetify';

@Component({
  components: {
    DialogInstallmentDetails,
    DialogInstallmentEdit,
    DialogRefundHistory,
    DialogPayment,
    DialogBankslipResend,
    DialogBrcodeResend,
    DialogChargebackDetails,
  },
})
export default class DataTabeInstallmentsComponent extends Vue {
  @Prop(Object) readonly data!: object;

  private headers: DataTableHeader[] = [];
  private loading = false;
  private dialog = false;
  private dialogRefundHistory = false;
  private dialogEdit = false;
  private dialogPayment = false;
  private dialogBankSlipResend = false;
  private dialogBrcodeResend = false;
  private dialogChargeback = false;

  private get refs() {
    return refsService;
  }
  private get installmentList(): InstallmentModel[] {
    return this.refs.modules.contract.installmentList;
  }
  private get installment(): InstallmentModel {
    return this.refs.modules.contract.installment;
  }
  private getFileConfirmationRefund(installmentId: string) {
    const url = this.refs.modules.contract.refundsByContract.filter(
      (x) =>
        x.InstallmentId?.toUpperCase() == installmentId.toUpperCase() &&
        x.FileConfirmationUri
    )[0].FileConfirmationUri;
    if (url) {
      window.open(url, '_blank');
    }
  }
  private verifyExistsInstallmentInRefunds(installmentId: string) {
    let result = false;
    const listRefunds = this.refs.modules.contract.refundsByContract;
    for (const refund of listRefunds) {
      if (refund.InstallmentId?.toUpperCase() == installmentId.toUpperCase()) {
        result = true;
        break;
      }
    }
    return result;
  }
  private verifyExistsInstallmentInRefundsFinalized(installmentId: string) {
    let result = false;
    const listRefunds = this.refs.modules.contract.refundsByContract;
    for (const refund of listRefunds) {
      if (
        refund.InstallmentId?.toUpperCase() == installmentId.toUpperCase() &&
        refund.FileConfirmationUri
      ) {
        result = true;
        break;
      }
    }
    return result;
  }
  private paymentInfo(paymentInfos: PaymentInfoModel[]) {
    let result = '';
    paymentInfos.map((paymentInfo) => {
      if (paymentInfo) {
        if (result) {
          result += '<br/>';
        }
        if (
          this.refs.enums.PaymentMethod[paymentInfo.PaymentMethod] ==
          this.refs.enums.PaymentMethod.Debit.toString()
        )
          result += `Ag. ${
            paymentInfo.BranchNumber && paymentInfo.BranchDigit
              ? `${paymentInfo.BranchNumber}-${paymentInfo.BranchDigit}`
              : paymentInfo.BranchNumber || paymentInfo.BranchDigit || '--'
          }
        <br />Cc. ${
          paymentInfo.AccountNumber && paymentInfo.AccountDigit
            ? `${paymentInfo.AccountNumber}-${paymentInfo.AccountDigit}`
            : paymentInfo.AccountNumber || paymentInfo.AccountDigit || '--'
        }`;
        else if (
          this.refs.enums.PaymentMethod[paymentInfo.PaymentMethod] ==
            this.refs.enums.PaymentMethod.BankSlip.toString() ||
          this.refs.enums.PaymentMethod[paymentInfo.PaymentMethod] ==
            this.refs.enums.PaymentMethod.BRCode.toString()
        ) {
          result = this.refs.static.enumDescriptions.get2(
            this.refs.enums.PaymentMethod,
            paymentInfo.PaymentMethod
          );
        } else if (
          this.refs.enums.PaymentMethod[paymentInfo.PaymentMethod] ==
          this.refs.enums.PaymentMethod.Credit.toString()
        )
          result += paymentInfo.CardTruncatedNumber || '--';
      }
    });
    return result;
  }

  private TypePaymentInfo(paymentInfos: PaymentInfoModel[]) {
    let result = '';
    paymentInfos.map((paymentInfo) => {
      if (paymentInfo) {
        result = this.refs.enums.PaymentMethod[paymentInfo.PaymentMethod];
      }
    });
    return result;
  }

  private created(): void {
    this.headers = [
      { text: this.$t('headers.status').toString(), value: 'Status' },
      {
        text: this.$t('headers.installment').toString(),
        value: 'Number',
      },
      {
        text: this.$t('headers.type').toString(),
        value: 'InstallmentType',
      },
      {
        text: this.$t('headers.attempts').toString(),
        value: 'CurrentAttemptNumber',
      },
      {
        text: this.$t('headers.integration_identifier').toString(),
        value: 'OurCode',
      },
      {
        text: this.$t('headers.installment_maturity').toString(),
        value: 'OriginalDueDate',
      },
      {
        text: this.$t('headers.reference').toString(),
        value: 'MonthReference',
      },
      {
        text: this.$t('labels.payment_method').toString(),
        value: 'PaymentInfos',
      },
      { text: this.$t('headers.value').toString(), value: 'Value' },
      { text: '', value: 'Actions', sortable: false, align: 'end' },
    ];
  }

  private async loadInstallment(installment: InstallmentModel) {
    this.loading = true;
    this.refs.modules.contract.SET_INSTALLMENT(installment);
    const paymentInfo = this.refs._.head(this.installment.PaymentInfos);
    if (paymentInfo)
      this.refs.modules.contract.SET_INSTALLMENT_PAYMENT_INFO(paymentInfo);
    this.refs.modules.contract
      .loadAttemptList({
        contractId: this.refs.modules.contract.contract.Id,
        installmentId: this.refs.modules.contract.installment.Id,
      })
      .then(() => (this.dialog = true))
      .catch((err) => this.$toast.error('ERROR ? ', err))
      .finally(() => (this.loading = false));
  }

  private async loadChargebackHistory(installment: InstallmentModel) {
    this.loading = true;
    this.refs.modules.contract.SET_INSTALLMENT(installment);
    this.refs.modules.contract
      .loadChargebackHistory({
        contractId: this.refs.modules.contract.contract.Id,
        installmentId: installment.Id,
      })
      .then(() => (this.dialogChargeback = true))
      .catch((err) => this.$toast.error('ERROR ? ', err))
      .finally(() => (this.loading = false));
  }

  private loadInstallmentEdit(installment: InstallmentModel) {
    this.refs.modules.contract.SET_INSTALLMENT(installment);
    this.refs.modules.contract.SET_INSTALLMENT_ORIGINALDUEDATE(installment);
    this.dialogEdit = true;
  }
  private loadInstallmentPayment(installment: InstallmentModel) {
    this.refs.modules.contract.SET_INSTALLMENT(installment);
    this.refs.modules.contract.SET_PAYMENT_DESTINATION(
      this.refs.enums.PaymentDestination.Parcel
    );
    this.dialogPayment = true;
  }
  private loadRefunds(installment: InstallmentModel) {
    this.refs.modules.contract.SET_INSTALLMENT(installment);
    this.dialogRefundHistory = true;
  }
  private loadBankSlipResend(installment: InstallmentModel) {
    this.refs.modules.contract.SET_INSTALLMENT(installment);
    this.dialogBankSlipResend = true;
  }
  private loadBRCodeResend(installment: InstallmentModel) {
    this.refs.modules.contract.SET_INSTALLMENT(installment);
    this.dialogBrcodeResend = true;
  }

  private async updateStatus(installment: InstallmentModel) {
    this.loading = true;
    this.refs.modules.contract.SET_INSTALLMENT(installment);
    this.refs;

    await Promise.all([
      this.refs.enums.InstallmentStatus[installment.Status] ==
      this.refs.enums.InstallmentStatus.PaidByOtherWay.toString()
        ? this.refs.modules.contract.paidByOtherWayInstallment({
            contractId: this.refs.modules.contract.contract.Id,
            installmentId: installment.Id,
            descReason: '',
          })
        : this.refs.enums.InstallmentStatus[installment.Status] ==
          this.refs.enums.InstallmentStatus.Canceled.toString()
        ? this.refs.modules.contract.cancelInstallment({
            contractId: this.refs.modules.contract.contract.Id,
            installmentId: installment.Id,
            descReason: '',
          })
        : this.refs.modules.contract.updateInstallment({
            contractId: this.refs.modules.contract.contract.Id,
            installmentId: installment.Id,
            installment: installment,
            descReason: '',
          }),
    ])
      .then(() => {
        this.$toast(this.$t('toasts.change_status_installment_successfully'));
      })
      .catch((err) => {
        this.$toast.error('ERROR ? ', err);
        this.$toast.error(this.$t('toasts.change_status_installment_error'));
      })
      .finally(async () => {
        await this.refs.modules.contract.loadInstallmentList(
          this.$route.params.id
        );
        this.loading = false;
      });
  }

  openDetail() {
    this.dialogChargeback = false;
    this.dialog = true;
  }

  forceUpdateStatus(
    installment: InstallmentModel,
    resend: boolean,
    approved: boolean,
    retriable: boolean
  ) {
    this.loading = true;

    const params = {
      resend: resend,
      approved: approved,
      retriable: retriable,
    };

    this.refs.modules.contract
      .forceUpdateStatus({
        contractId: this.refs.modules.contract.contract.Id,
        installmentId: installment.Id,
        params,
      })
      .then(() =>
        this.$toast(this.$t('toasts.change_status_installment_successfully'))
      )
      .catch((err) => this.$toast.error('ERROR ? ', err))
      .finally(async () => {
        await this.refs.modules.contract.loadInstallmentList(
          this.$route.params.id
        );
        this.loading = false;
      });
  }

  applicationMode() {
    return `${env.applicationMode}`;
  }
}
